import { types } from 'mobx-state-tree';

import { castEventToValue } from 'js/services/FormTools';

import Address from './Address';
import PaymentSeller from './PaymentSeller';
import Image from './Image';

export default types
  .model('PaymentLink', {
    price: types.optional(types.union(types.string, types.number), 0),
    deleted_at: types.optional(types.union(types.null, types.string, types.boolean), null),
    title: '',
    size: 'small',
    description: types.maybeNull(types.string),
    quantity: types.optional(types.union(types.string, types.number), 1),
    image: types.optional(Image, {}),
    alias: '',
    checkout_url: '',
    address: types.maybe(Address),
    seller: types.maybe(PaymentSeller),
    was_sold: false,
  })
  .actions(self => ({
    setAlias(alias) {
      self.alias = castEventToValue(alias);
      return self;
    },
    setTitle(title) {
      self.title = castEventToValue(title);
      return self;
    },
    setPrice(price) {
      self.price = castEventToValue(price);
      return self;
    },
    setQuantity(quantity) {
      self.quantity = castEventToValue(quantity);
      return self;
    },
    setDescription(description) {
      self.description = castEventToValue(description);
      return self;
    },
    setSize(size) {
      self.size = castEventToValue(size);
      return self;
    },
    markAsDeleted() {
      self.deleted_at = true;
      return self;
    },
    markAsSold() {
      self.quantity = 0;
      return self;
    },
    markAsAvailable() {
      self.quantity = 1;
      return self;
    },
  }));
